var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Polygon_2","data-name":"Polygon 2","d":"M28.43,1.988a2,2,0,0,1,3.14,0L57.443,34.761A2,2,0,0,1,55.873,38H4.127a2,2,0,0,1-1.57-3.239Z","transform":"translate(38) rotate(90)","fill":"#fff"}));
}

Play.defaultProps = {"width":"38","height":"60","viewBox":"0 0 38 60"};

module.exports = Play;

Play.default = Play;
